import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController } from 'ionic-angular';
import { NgwService } from '../../app/ngw.service';
import { PastGame } from './pastGame';
import { NgwGame, NgwTeam, NgwPlayer, NgwRound, NgwPick, NgwScore } from '../../app/classes/NgwGame';
import { TabsPage } from '../tabs/tabs';


@Component({
    templateUrl: 'pastGames.html'

})

export class PastGames implements OnInit {
    reverseGames: NgwGame[]


    constructor(public navCtrl: NavController, public ngwService: NgwService) {

    }

    ngOnInit(): void {
        
        this.reverseGames = [];
        if (this.ngwService.games) {
            for (var i = this.ngwService.games.length - 1; i >= 0; i--) {
                this.reverseGames.push(this.ngwService.games[i])
            }
        }

    }

    reloadGamesClicked() {
        this.navCtrl.setRoot(TabsPage);
    }
}


// WEBPACK FOOTER //
// ./src/pages/pastGames/pastGames.ts